export default {
  flattenCategoryTree(categoryTree) {
    const stack = [...categoryTree]
    const historyMap = {}
    const slugForKey = {}

    while (stack.length) {
      const next = stack.pop()

      // Change children to be an array of slugs
      if (Array.isArray(next.children)) {
        const subcategory = next.children
        stack.push(...subcategory)
        next.children = (next.children).map(child => child.slug)
      }

      // Add parent slug to keep track of parent
      const parentSlug = historyMap[next.parent_id]
      if (parentSlug) {
        next.parent_slug = parentSlug.slug
      }

      slugForKey[next.slug] = next
      historyMap[next.id] = next
    }
    return slugForKey
  },

  // Reduce flattened category tree with only neccessary attributes
  reduceFlattenedCategoryTree(categorySlugMap, attr = ['name', 'slug']) {
    const updatedTree = Object.keys(categorySlugMap).reduce((acc, categoryKey) => {
      const obj = categorySlugMap[categoryKey]
      acc[categoryKey] = attr.reduce((props, attrKey) => ({
        ...props,
        [attrKey]: obj[attrKey],
      }), {})
      return acc
    }, {})
    return updatedTree
  },

  /*
    Add slug to store name to avoid confusion
    e.g Glow Gorgeous => Glow Gorgeous (glow-gorgeous-sg)
  */
  handleStoreNameCollision(stores) {
    const storeMap = new Map()
    stores.forEach(({ name }) => {
      const count = storeMap.get(name)
      if (count) {
        storeMap.set(name, count + 1)
      } else {
        storeMap.set(name, 1)
      }
    })
    stores.map((store) => {
      if (storeMap.get(store.name) > 1) {
        store.name = `${store.name} (${store.slug})`
      }
      return store
    })
    return stores
  },
}
